import TableTitle from './TableTitle';

export default TableTitle;
